<template>
  <article class="analysisA" :class="{hidden: !pageStatus.isLoaded}">
    <ul class="tab-service-detail">
      <li v-for="(item, index) in tabList" @click="onShiftTab(item)" :class="{on:item.on}" :key="index">
        <a href="javascript:void(0);">{{item.name}}</a>
      </li>
    </ul>
    <div class="blank"></div>
    <div class="car-all">
      <!-- 昨天、前天/本月、上个月 -->
      <cell :title="storeName" class="top-title">
        <span slot="after-title" class="title-date">|&nbsp;&nbsp;{{this.showDate}}</span>
        <button
          slot="child"
          class="btn-default btn-margin"
          v-for="(item, index) in tabObj[tabStatus]"
          :key="index"
          :class="{'btn-select': period === item.key}"
          @click.stop="selectTab(item.key)"
        >
          {{item.name}}
        </button>
      </cell>

      <component-fans
        :total="fansTotal"
      ></component-fans>

      <chart
        :options="option"
        theme="lineChart"
        auto-resize
        class="mychart"
        v-show="tabList[1].on && tabList[1].id === 'month'"
      ></chart>

      <div v-if="hasGroupAuth">
        <p class="table-title">门店统计</p>
        <component-table
          :titles="tableTitle"
          :keyArray="keyArray"
          :lists="storesDetail"
          :mainTitle="mainTitle"
          mainName="name"
          :date="day"
          :flag="flagA"
          :isDay="tabList[0].on && tabList[0].id === 'date'"
          class="table-scroll"
          url="/manageAnalysis/fansDetailDaily"
        ></component-table>
      </div>
    </div>
  </article>
</template>
<script>
// echarts 组件是否加载完毕
import theme from './myLineChart.json'
import util from '../../common/util'
// import cookie from '../../common/cookie'
import ComponentTable from './ComponentTable'
import ComponentFans from './ComponentFans'
import {
  Cell
} from '@lx-frontend/cvux'
let status = {}
status.isLoaded = false
const Chart = () => import(/* webpackChunkName: "ECharts" */ 'vue-echarts').then(ECharts => {
  ECharts.registerTheme('lineChart', theme)
  status.isLoaded = true
  return ECharts
})
export default {
  components: {
    Cell,
    Chart,
    ComponentTable,
    ComponentFans
  },
  data() {
    return {
      pageStatus: status, // 状态信息
      storeName: '',
      hasGroupAuth: false,
      option: {}, // 曲线图数据与设置
      mainTitle: { name: '门店' },
      keyArray: ['total_fans', 'subscribed', 'unsubscribed', 'total_boud', 'bound'],
      tableTitle: [
        { name: '粉丝总数' },
        { name: '新增关注' },
        { name: '取消关注' },
        { name: '绑定总数' },
        { name: '新增绑定' }
      ],
      tabList: [{
        id: 'date',
        name: '日',
        on: false
      }, {
        id: 'month',
        name: '月',
        on: true
      }],
      // 定义昨日、前天、本月、上个月数据结构
      tabObj: {
        date: [
          {
            key: 'yesterday',
            name: '昨天'
          }, {
            key: 'beforeYesterday',
            name: '前天'
          }
        ],
        month: [
          {
            key: 'this_month',
            name: '本月'
          }, {
            key: 'last_month',
            name: '上个月'
          }
        ]
      },
      period: 'this_month', // 默认日期是昨天/本月
      tabStatus: 'month', // 每日/每月数据
      showDate: '', // 展示当前数据日期or月份
      day: util.formatTime(new Date(), 'yyyy-MM-dd'), // 获取当前日期
      storeId: '', // 参数门店ID
      flagA: true, // 默认日期是今天/本月
      fansDaily: {},
      storesDetail: [],
      fansTotal: {},
      daysChart: [],
      days: [], // 趋势图X轴刻度
      newFans: [], // 新增关注
      newbound: [] // 新增绑定
    }
  },
  async created() {
    await this.setParams()
    // this.storeId = +cookie.getCookie('store_id')
    // // 是否有权限查看集团范围数据
    // this.hasGroupAuth = cookie.getCookie('view_group') === 'true' ? 1 : false
    this.storeName = this.hasGroupAuth ? '粉丝运营统计' : ''
    this.queryData(this.day)
  },
  methods: {
    async setParams () {
      try {
        const { code, data, message } = await this.$rest.dataAnalysis.getCarAuth()
        if (code !== 0) {
          this.showToast(message)
          return
        }

        this.storeId = +data.store_id
        this.hasGroupAuth = data.view_group === 'true' ? 1 : false
      } catch (e) {
        this.showToast(e.message)
      }
    },
    // 获取对应单店信息
    getStoreDetail(data) {
      // 根据上页面传递进来store_id找出特定门店数据
      if (!this.hasGroupAuth) {
        data.find(vl => {
          if (vl.store_id === this.storeId) {
            this.storeName = vl.name
          }
        })
      }
    },
    queryData(chooseDate) {
      let tmp = {}
      if (this.hasGroupAuth) {
        tmp = {
          date: chooseDate // this.day
        }
      } else {
        tmp = {
          date: chooseDate,
          store_id: this.storeId
        }
      }
      let params = tmp
      let DayOrMonth = ''
      let tabDate = true // 当前选中tab是日数据
      if (this.tabList[0].on && this.tabList[0].id === 'date') {
        DayOrMonth = this.$rest.dataAnalysis.getFansDaily // 调用日数据接口
      } else {
        DayOrMonth = this.$rest.dataAnalysis.getFansMonthly // 调用月数据接口
        tabDate = false
      }
      DayOrMonth(params).then(res => {
        if (res.code === 0) {
          let selectDate = ''
          let dateObj = {}
          this.fansDaily = res.data
          selectDate = Object.keys(this.fansDaily)[0] || ''
          this.showDate = tabDate ? selectDate : selectDate.slice(0, 7) // 日期
          dateObj = Object.values(this.fansDaily)[0]
          this.storesDetail = dateObj.stores_detail
          this.getStoreDetail(this.storesDetail) // 根据store_id找出特定门店数据
          this.fansTotal = dateObj.total
          if (!tabDate) { // 月数据时的折线图数据
            this.daysChart = dateObj.days_detail
            this.cleanChart()
            this.daysChart.forEach(v => {
              let dayX = v.date.replace(/-/g, '/').slice(5)
              this.days.push(dayX)
              this.newFans.push(v.subscribed)
              this.newbound.push(v.bound)
            })
            this.option = this.getEchart(this.days, this.newFans, this.newbound)
          }
        } else {
          this.showToast(res.message)
        }
      })
      if (!tabDate) {
        this.option = this.getEchart(this.days, this.newFans, this.newbound)
      }
    },
    // 折线图
    getEchart(time, newFans, newbound) {
      let chartData = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            crossStyle: {
              color: '#999'
            }
          }
        },
        title: {
          text: '趋势图',
          textStyle: {
            color: '#666',
            fontSize: 13,
            fontWeight: 'normal'
          }
        },
        legend: {
          bottom: 10,
          data: [{
            name: '新增关注'
          }, {
            name: '新增绑定'
          }]
        },
        xAxis: {
          type: 'category', // 坐标轴类型
          boundaryGap: false, // 坐标轴两边留白策略
          data: time // this.days
        },
        yAxis: {
          type: 'value'
        },
        series: [{
          name: '新增关注',
          type: 'line',
          data: newFans, // this.newFans,
          markPoint: {
            data: [
              { type: 'max', name: '最大值' }
            ]
          }
        }, {
          name: '新增绑定',
          type: 'line',
          data: newbound // this.newbound
        }]
      }
      return chartData
    },
    onShiftTab (item) {
      if (this.tabStatus === item.id) return false
      this.tabList.forEach((tab) => {
        if (item.id === tab.id) {
          tab.on = true // 月或日被选中
          this.tabStatus = tab.id // 赋值tabStatus当前被选中值
          this.period = tab.id === 'month' ? 'this_month' : 'yesterday' // 转换日/月tab时默认选项今日/本月
          this.selectTab(this.period)
        } else {
          tab.on = false
        }
      })
    },
    // 昨天、前天/本月、上个月切换
    selectTab(key) {
      this.period = key
      switch (key) {
        case 'yesterday':
          let yesterday = new Date(new Date() - 24 * 60 * 60 * 1000)
          this.day = util.formatTime(yesterday, 'yyyy-MM-dd')
          this.flagA = true
          break
        case 'beforeYesterday':
          let beforeYesterday = new Date(new Date() - 2 * 24 * 60 * 60 * 1000)
          this.day = util.formatTime(beforeYesterday, 'yyyy-MM-dd')
          this.flagA = false
          break
        case 'this_month':
          this.day = util.formatTime(new Date(), 'yyyy-MM-dd')
          this.flagA = true
          break
        case 'last_month':
          let today = util.formatTime(new Date(), 'yyyy-MM')
          this.day = util.getLastMonth(today) + '-01'
          this.flagA = false
          break
      }
      this.cleanChart()
      this.queryData(this.day)
    },
    cleanChart() {
      this.days = []
      this.newFans = []
      this.newbound = []
    }
  }
}
</script>
<style rel="stylesheet/less" lang="less">
@import "../../stylesheets/modules/data/carData.less";
</style>
